module.exports = __webpack_public_path__ + "media/img/patterns/crosshair-grid-light-c9ec2ada2f09a6406894cd6edb75d386.png";